// extracted by mini-css-extract-plugin
export default {"photosEdit":"PhotosEdit_photosEdit__Fqjxa","dropContainer":"PhotosEdit_dropContainer__B8jBN","saveButton":"PhotosEdit_saveButton__s7Sdx"};